import Vue from 'vue'
import PrivacyInstance from './src/instance'
import Privacy from './src/Index'
Vue.prototype.$showPrivacy = PrivacyInstance
export default Privacy

